import { getDefaultExportFromCjs as r } from "./index.es469.js";
import { __require as o } from "./index.es479.js";
var t = /* @__PURE__ */ o();
const s = /* @__PURE__ */ r(t);
export {
  s as default
};
//# sourceMappingURL=index.es437.js.map
